<template>
   <div class="border-top">
       <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-center">
           <h3 class="mt-2">{{$t('preference_information') + ' ' + $t('add')}}</h3>
           <b-button  @click="newApplication" class="small mt-5" v-if="showNewRequest">
               {{ $t('application_new').toUpper() + ' ' +$t('create')}}
           </b-button>
       </div>

       <ValidationObserver ref="preferenceInformation" v-slot="{ invalid }">
           <b-row class="mt-5">
               <b-col cols="12" md="4">
                   <ValidationProvider name="faculty_code" rules="required" v-slot="{ valid, errors }">
                       <b-form-group :label="$t('faculty')">
                           <faculty-selectbox v-model="form.faculty_code" :validate-error="errors[0]"></faculty-selectbox>
                       </b-form-group>
                   </ValidationProvider>
               </b-col>
               <b-col cols="12" md="4">
                   <ValidationProvider name="department_code" rules="required" v-slot="{ valid, errors }">
                       <b-form-group :label="$t('department')">
                           <department-selectbox v-model="form.department_code"
                                                 :faculty_code="form.faculty_code" :validate-error="errors[0]" />
                       </b-form-group>
                   </ValidationProvider>
               </b-col>
               <b-col cols="12" md="4">
                   <ValidationProvider name="program_code" rules="required" v-slot="{ valid, errors }">
                       <b-form-group :label="$t('program')">
                           <program-selectbox v-model="form.program_code" :faculty_code="form.faculty_code"
                                              :department_code="form.department_code" :validate-error="errors[0]" />
                       </b-form-group>
                   </ValidationProvider>
               </b-col>
               <b-col cols="12" md="4">
                   <ValidationProvider name="rank" rules="required" v-slot="{errors}">
                       <b-form-group :label="$t('rank')">
                           <ParameterSelectbox code="preference_order_application_module" v-model="form.rank" :validate-error="errors[0]"/>
                       </b-form-group>
                   </ValidationProvider>
               </b-col>

               <b-col cols="12" class="d-flex justify-content-center align-items-center mt-1" v-if="checkPermission('promotionalprocesspreference_store')">
                   <ProcessingButton :label="$t('add')" @click="addPreference" :processing="loading"  :disabled="invalid">
                       <i class="ri-add-line mr-2"></i>
                   </ProcessingButton>
               </b-col>

           </b-row>
       </ValidationObserver>

       <datatable :title="$t('preference_information')"
                  :isLoading.sync="datatable.isLoading"
                  :columns="datatable.columns"
                  :sort-options="{
                      enabled:true,
                      initialSortBy:{field:'rank',type:'desc'}
                  }"
                  :rows="datatable.rows"
                  :total="datatable.total" :queryParams="datatable.queryParams" :show-table="true">
       </datatable>
       <CommonModal ref="updatePreferenceModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
           <template v-slot:CommonModalTitle>
               {{ $t('update').toUpper() }}
           </template>
           <template v-slot:CommonModalContent>
              <UpdatePreferences v-if="formProcess==='update_preferences'" :formId="formId" :form="form" :promotionalProcessId="promotionalProcessId" @updateSuccess="updateSuccess"/>
           </template>
       </CommonModal>
   </div>
</template>
<script>
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import PromontionApplicationServices from "@/services/PromontionApplicationServices";
import qs from "qs";
import UpdatePreferences from "@/modules/promontialApplicationForm/pages/components/UpdatePreferences.vue";

export default {
    components: {UpdatePreferences, ProcessingButton},
    props:{
        promotionalProcessId:{
            type:Number,
            required:true
        }
    },
   data(){
       return {
           formId:null,
           loading:false,
           formProcess:null,
           maximum_number_of_application:3,
           form:{},
           showNewRequest:false,
           datatable: {
               isLoading: false,
               columns: [
                   {
                       label: '',
                       field: 'buttons',
                       html: true,
                       sortable: false,
                       tdClass: 'p-0 text-center w-40 align-middle',
                       buttons: [
                           {
                               text: this.$t('edit'),
                               class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
                               permission: "promotionalprocesspreference_update",
                               callback: (row) => {
                                   this.updateFormShow(row.id)
                               }
                           },
                       ]
                   },
                   {
                       label: this.$t('id'),
                       field: 'id',
                       hidden: true,
                   },
                   {
                       label: this.$t('rank'),
                       field: 'rank',
                       hidden: false,
                       tdClass: 'text-center',
                       thClass: 'text-center',
                   },
                   {
                       label: this.$t('faculty_name'),
                       field: 'faculty_name',
                       hidden: false,
                       tdClass: 'text-center',
                       thClass: 'text-center',
                   },
                   {
                       label: this.$t('department_name'),
                       field: 'department_name',
                       hidden: false,
                       tdClass: 'text-center',
                       thClass: 'text-center',
                   },
                   {
                       label: this.$t('program_name'),
                       field: 'program_name',
                       hidden: false,
                       tdClass: 'text-center',
                       thClass: 'text-center',
                   },
                   {
                       label: this.$t('point_type'),
                       field: 'point_type',
                       hidden: false,
                       tdClass: 'text-center',
                       thClass: 'text-center',
                   },
                   {
                       label: this.$t('success_ranking'),
                       field: 'success_ranking',
                       hidden: false,
                       tdClass: 'text-center',
                       thClass: 'text-center',
                   },


               ],
               rows: [],
               total: 0,
               filterStatus: true,
               showTable: false,
               queryParams: {
                   filter: {
                       promotional_process_id:this.promotionalProcessId
                   },
                   sort: '-id',
                   page: 1,
                   limit: 5
               }
           },
       }
   },
    watch:{
      'datatable.rows'(newVal){
          if (newVal && newVal.length===this.maximum_number_of_application){
             this.showNewRequest=true
          }
      },
    },
    computed:{
        rankOptions() {
            return [
                {
                    text:'1',
                    value:1
                },
                {
                    text:'2',
                    value:2
                },
                {
                    text:'3',
                    value:3
                }
            ]
        },
    },
    methods:{
        formClear(){
          this.formProcess=null
        },
        async addPreference(){
            const isValid=await this.$refs.preferenceInformation.validate();
            if (!isValid)return
            this.loading=true
            try {
                this.form.promotional_process_id=this.promotionalProcessId
                const res =await PromontionApplicationServices.addPreference(this.form)
                this.$toast.success(this.$t('api.'+res.data.message))
                this.clearForm()
                await this.getPreferences()
            }catch (error) {
                this.showErrors(error,this.$refs.preferenceInformation)
            }finally {
                this.loading=false
            }
        },
        async getPreferences(){
            this.datatable.isLoading=true;
            try {
                const config={
                    params:{
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }
                const res = await PromontionApplicationServices.getPreferences(config)
                const data =res.data.data
                if (data && data.length){
                    this.datatable.rows = data.sort((a,b)=>a.rank-b.rank)
                }
                this.datatable.total = res.data.pagination.total
            }catch (err){
                this.showErrors(err,this.$refs.preferenceInformation)
            }finally {
                this.datatable.isLoading=false;
            }
        },
        clearForm(){
          this.form ={
              faculty_code:null,
              department_code:null,
              rank:null
          }
        },
        updateFormShow(id){
            this.formId=id
            this.formProcess='update_preferences'
            this.$refs.updatePreferenceModal.$refs.commonModal.show()
        },
        newApplication(){
            window.location.reload();
        },
        updateSuccess(){
            this.formId=null
            this.formProcess=null
            this.$refs.updatePreferenceModal.$refs.commonModal.hide()
            this.getPreferences()
        }
    }

}
</script>

<style scoped>

</style>
